import { Link } from 'react-router';
import styled from 'styled-components';
import { theme } from '../../utils/Theme';

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2.5rem;
  gap: 1.2rem;
  
  @media screen and (max-width: 440px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const ResumeButton = styled.a`
  display: inline-block;
  background-color: inherit;
  min-width: 150px;
  text-align: center;
  width: max-content;
  color: ${theme.blueColor};
  padding: 0.75rem 1.2rem;
  border-radius: 0.4rem;
  cursor: pointer;
  border: 1px solid ${theme.blueColor};
  transition: var(--transition);

  &:hover {
    background: ${theme.whiteColor};
    color: ${theme.backgroundColor};
    border-color: transparent;
  }

  @media screen and (max-width: 450px) {
    padding: 0.5rem 0.75rem;
  }
`;

export const ContactButton = styled(ResumeButton)`
  background-color: ${theme.blueColor};
  color: ${theme.backgroundColor};
`;

export const SocialsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
  position: absolute;
  left: 10rem;
  bottom: 3rem;

  @media screen and (min-width: 1025px) {
    &::before {
      content: '';
      width: 1px;
      height: 2rem;
      background: ${theme.blueColor};
    }

    &::after {
      content: '';
      width: 1px;
      height: 2rem;
      background: ${theme.blueColor};
    }
  }

  @media screen and (max-width: 1024px) {
    flex-direction: row;
    position: initial;
    justify-content: center;
    margin-top: 2rem;
  }
`;

export const SocialButton = styled.a`
  &:hover {
    transform: scale(1.1);
  }
`;

export const SocialButtonImg = styled.img`
  background-color: ${theme.blueColor};
  border-radius: 3px;
  width: 1rem;
  height: 1rem;
`;

export const ProfileContainer = styled.div`
  width: 22rem;
  height: max-content;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 3rem;
  overflow: hidden;
  border: 3px solid white;
  border-radius: 30% 25% 25% 30% / 30% 25% 25% 30%;
  animation: morph 8s ease-in-out infinite;
  padding: 3%;
    background: #fff;

  @keyframes morph {
      0% {
          border-radius: 30% 25% 25% 30% / 30% 25% 25% 30%;
      }
      50% {
          border-radius: 35% 30% 30% 35% / 35% 30% 30% 35%;
      }
      100% {
          border-radius: 30% 25% 25% 30% / 30% 25% 25% 30%;
      }
  }
  @media screen and (max-width: 1280px) {
    width: 18rem;
  }
`;

export const ScrollDown = styled.a`
  position: absolute;
  color: ${theme.blueColor};
  right: 10rem;
  bottom: 5rem;
  transform: rotate(90deg);
  font-weight: 300;
  font-size: var(--fs-12);
  animation: up-down 4s ease infinite;
  animation-delay: 12.5s;
  &:hover {
    cursor: pointer;
  }

  @keyframes up-down {
    0% {
      bottom: 5rem;
    }
    50% {
      bottom: 4rem;
    }
    100% {
      bottom: 5rem;
    }
  }

  @media screen and (max-width: 1280px) {
    right: 2rem;
  }

  @media screen and (max-width: 1024px) {
    visibility: hidden;
  }
`;

export const StyledTitle = styled.h5`
  color: ${theme.greyColorText};
`;

export const PhotoProfile = styled.img`
    width: 100%;
    height: auto;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
`;

export const LanguageContainer = styled.div`
  position: absolute;
  top: -2rem;
  right: 0;
  display: flex;
  &:hover {
    cursor: pointer;
  }
`;

export const LanguageIcon = styled.img`
  height: 1.5rem;
  width: 1.5rem;
  transition: .3s;
  &:hover {
    scale: 1.2;
  }

  @media screen and (max-width: 440px) {
    height: 1rem;
    width: 1.25rem;
  }
`;

export const LinkButton = styled(Link)`
    display: inline-block;
    background-color: inherit;
    min-width: 150px;
    text-align: center;
    width: max-content;
    color: ${theme.blueColor};
    padding: 0.75rem 1.2rem;
    border-radius: 0.4rem;
    cursor: pointer;
    border: 1px solid ${theme.blueColor};
    transition: var(--transition);

    &:hover {
        background: ${theme.whiteColor};
        color: ${theme.backgroundColor};
        border-color: transparent;
    }

    @media screen and (max-width: 450px) {
        padding: 0.5rem 0.75rem;
    }
`;
